export var MobileWebviewCommunicationActions = /*#__PURE__*/ function(MobileWebviewCommunicationActions) {
    MobileWebviewCommunicationActions["AppForeground"] = "app_foreground";
    MobileWebviewCommunicationActions["AppBackground"] = "app_background";
    MobileWebviewCommunicationActions["BackButtonPressed"] = "back_button_pressed";
    MobileWebviewCommunicationActions["GameStarted"] = "game_started";
    MobileWebviewCommunicationActions["LobbyLoaded"] = "lobby_loaded";
    MobileWebviewCommunicationActions["OrientationPortrait"] = "orientation_portrait";
    MobileWebviewCommunicationActions["OrientationLandscape"] = "orientation_landscape";
    MobileWebviewCommunicationActions["Resize"] = "resize";
    MobileWebviewCommunicationActions["ShareLink"] = "room_link";
    MobileWebviewCommunicationActions["ShareImage"] = "share_image";
    MobileWebviewCommunicationActions["RequestNotificationPermission"] = "request_notification_permission";
    MobileWebviewCommunicationActions["NotificationSetExternalUserId"] = "notification_set_external_user_id";
    MobileWebviewCommunicationActions["RequestReview"] = "request_review";
    MobileWebviewCommunicationActions["ShowTextNotification"] = "show_text_notification";
    MobileWebviewCommunicationActions["ShowTopBottomSafeArea"] = "show_top_bottom_safe_area";
    MobileWebviewCommunicationActions["ShowSplashScreen"] = "should_show_splash_screen";
    MobileWebviewCommunicationActions["AppEncounteredError"] = "app_encountered_error";
    MobileWebviewCommunicationActions["PurchaseProduct"] = "purchase_product";
    MobileWebviewCommunicationActions["GiftMembership"] = "gift_membership";
    MobileWebviewCommunicationActions["PurchaseMembership"] = "purchase_membership";
    MobileWebviewCommunicationActions["LocalizedPricingSubscriptions"] = "localized_pricing_subscriptions";
    MobileWebviewCommunicationActions["LocalizedPricingProducts"] = "localized_pricing_products";
    MobileWebviewCommunicationActions["UserCancelledPurchase"] = "user_cancelled_purchase";
    MobileWebviewCommunicationActions["ShowManageSubscriptions"] = "show_manage_subscriptions";
    MobileWebviewCommunicationActions["IAPCompleted"] = "iap_completed";
    MobileWebviewCommunicationActions["BannerAd"] = "banner_ad";
    return MobileWebviewCommunicationActions;
}({});
export function isTwoWayCommunicationAction(action) {
    return Object.values(MobileWebviewCommunicationActions).includes(action);
}
